import { acceptHMRUpdate, defineStore } from 'pinia'

import { i18n } from '@/i18n'
import { useCartStore } from '@/stores/cart'

const _flowCrumbs = [
  {
    value: 'empty',
    hidden: true,
  },
  {
    value: 'view',
    title: i18n.global.te('cart.steps.view.crumbs')
      ? i18n.global.t('cart.steps.view.crumbs')
      : 'cart.steps.view.crumbs',
    nextButtonId: 'cart-continue-to-shipping-button',
  },
  {
    value: 'shipping',
    title: i18n.global.te('cart.steps.shipping.crumbs')
      ? i18n.global.t('cart.steps.shipping.crumbs')
      : 'cart.steps.shipping.crumbs',
    nextButtonId: 'cart-continue-to-billing-button',
  },
  {
    value: 'billing',
    title: i18n.global.te('cart.steps.billing.crumbs')
      ? i18n.global.t('cart.steps.billing.crumbs')
      : 'cart.steps.billing.crumbs',
    nextButtonId: 'cart-continue-to-review-button',
  },
  {
    value: 'review',
    title: i18n.global.te('cart.steps.review.crumbs')
      ? i18n.global.t('cart.steps.review.crumbs')
      : 'cart.steps.review.crumbs',
    nextButtonId: 'cart-submit-quote-bottom-button',
  },
  {
    value: 'confirmation',
    hidden: true,
  },
]

export const useCartFlowStore = defineStore('cart-flow', {
  state: () => ({
    step: _flowCrumbs.find((el) => el.value === 'empty'),
  }),

  getters: {
    crumbs: () => {
      const cartStore = useCartStore()

      return cartStore.isCartGuestView
        ? _flowCrumbs.filter((el) => !['shipping', 'billing'].includes(el.value))
        : _flowCrumbs
    },
  },

  actions: {
    setStep(stepData) {
      const cartStore = useCartStore()

      const fallbackStep = cartStore.productsQty ? this.crumbs[1] : this.crumbs[0]
      const step = this.crumbs.find((el) => el.value === stepData) || fallbackStep
      this.step = step
      if (document.querySelector('.steps')) {
        document.querySelector('.steps').scrollIntoView()
      }
    },

    incrementStep() {
      const valuesArr = this.crumbs.map((el) => el.value)
      const currStepIndex = valuesArr.indexOf(this.step.value)
      this.step = this.crumbs[currStepIndex + 1]
    },

    decrementStep() {
      const valuesArr = this.crumbs.map((el) => el.value)
      const currStepIndex = valuesArr.indexOf(this.step.value)
      this.step = this.crumbs[currStepIndex - 1]
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCartFlowStore, import.meta.hot))
}
